import React, { useContext, useState } from 'react';
import SchoolContext from '../../Context/SchoolContext';
import ajaxSchool from '../../remote/ajaxSchool';
import dictionary from '../../util/dictionary';
import ActivityLoader from '../Common/ActivityLoader';
import AlertError from '../Common/AlertError';
import AlertSuccess from '../Common/AlertSuccess';
import TextInput from '../Common/TextInput';

const NewBillingBatch=(props)=>{

const [info, setInfo] = useState("");
const [loading, setLoading] = useState(false)
const [batchName, setBatchName] = useState("");
const [starts, setStarts] = useState("");
const [ends, setEnds] = useState("")

const {listBillingBatches} = useContext(SchoolContext);


const onSave=async(event)=>{
    event.preventDefault();

    if(batchName.length>0 && starts.length>0 && ends.length>0)
    {
        setLoading(true)
        const server_response = await ajaxSchool.addBatch(batchName, starts, ends);
        setLoading(false)

        if(server_response.status==="OK")
        {
            setInfo(<AlertSuccess message={server_response.message}/>)
            setBatchName("")
            setStarts("")
            setEnds("")
            listBillingBatches()
        }else{
            setInfo(<AlertError message={server_response.message}/>)
        }
    }else{
        setInfo(<AlertError message={dictionary._completeFields}/>)
    }
}




    return (
        <div className='card'>

                <div className='card-body'>
                  <form className='form-horizontal' onSubmit={onSave}>
                    {info}
                    {loading && <ActivityLoader />}

                    <TextInput
                      type='text'
                      label='Title'
                      placeholder='Batch reference title'
                      leftIcon='fa fa-tag'
                      value={batchName}
                      onChange={(e)=>setBatchName(e.target.value)}
                      required
                    />

                    <div className='row'>&nbsp;</div>

                    <TextInput
                      type='date'
                      label='Starts'
                      placeholder='Start Date'
                      leftIcon='fa fa-calendar'
                      value={starts}
                      onChange={(e)=>setStarts(e.target.value)}
                    />

                    <div className='row'>&nbsp;</div>

                    <TextInput
                      type='date'
                      label='Ends'
                      placeholder='End Date'
                      leftIcon='fa fa-calendar'
                      value={ends}
                      onChange={(e)=>setEnds(e.target.value)}
                    />

                    <div className='row'>&nbsp;</div>

                    <div className='modal-footer no-border'>
                      {!loading && (
                        <button type='submit' className='btn btn-primary'>
                          Save Billing Batch
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
    );
}

export default NewBillingBatch;